import { useContext } from "react";
import { convertToJalali, formatGregorianDate } from "../../../../utils/date";
import { convertToTime } from "../../../../utils/time";
import { t } from "i18next";
import { LocaleContext } from "../../../../routing/LangRouter";
import BaseTable from "../../../common/base-table/base-table";

//styles
import "./table.scss";


export default function WalletTable({ transeActionList, loading = false }) {
    const { locale } = useContext(LocaleContext);

    //separate numbers with commas
    function numberWithCommas(x) {
        if (x) {
            x = x.toString();
            var pattern = /(-?\d+)(\d{3})/;
            while (pattern.test(x)) x = x.replace(pattern, "$1,$2");
            return x;
        }
        return x;
    }

    // Define columns for BaseTable
    const columns = [
        {
            accessorKey: 'status',
            header: t("type"),
            Cell: ({ row }) => (
                <span className={`transactions-table__body-column ${row.original.transaction_type}`}>
                    {row.original.status}
                </span>
            ),
        },
        {
            accessorKey: 'amount',
            header: t("amount"),
            Cell: ({ row }) => (
                <span className={`transactions-table__body-column ${row.original.transaction_type}`}>
                    {numberWithCommas(row.original.amount)} {t("currency")}
                </span>
            ),
        },
        {
            accessorKey: 'reference_id',
            header: t("trackingCode"),
            Cell: ({ row }) => (
                <span className="transactions-table__body-column table-mobile-display">
                    {row.original.reference_id}
                </span>
            ),
        },
        {
            accessorKey: 'date',
            header: t("dateAndTime"),
            enableSorting: false,
            Cell: ({ row }) => (
                <span className="transactions-table__body-column table-mobile-display">
                    {locale === "fa"
                        ? convertToJalali(row.original.date)
                        : formatGregorianDate(row.original.date, null, "YYYY/MM/DD")} - {convertToTime(row.original.date)}
                </span>
            ),
        },
    ];

    // Transform data to include any additional properties needed
    const transformedData = transeActionList.map(item => ({
        ...item,
    }));

    
    return (
            <BaseTable
                columns={columns}
                rows={transformedData}
                loading={loading}
                rowBackground="transparent" 
            />
    );
}